import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import { useContext } from "react"
import { EquipmentType } from "@/types/common"
import { ValveUnit } from "./components/ValveUnit/ValveUnit"
import "./unit.less";
import classNames from "classnames"
import { BatteryLimit } from "./components/BatteryLimit/BatteryLimit"
import { StreamSplitter } from "./components/StreamSplitter/StreamSplitter"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { UnitTag } from "./UnitTag"
import { getSimUnitData } from "@/services/project/simulation.service"
import { useRequest, useUpdateEffect } from "ahooks"
import { getFlowSimulationSelector, getTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"
import { StreamMixer } from "./components/StreamMixer/StreamMixer"
import { Pumps } from "./components/Pumps/Pumps"
import { Reactor } from "./components/Reactor/Reactor"
import { Burner } from "./components/Burner/Burner"
import { VerticalVessel } from "./VerticalVessel/VerticalVessel"
import { VesselWithInletManifold } from "./VesselWithInletManifold/VesselWithInletManifold"
import { VesselWithInletAndLiquidOutletManifold } from "./VesselWithInletAndLiquidOutletManifold/VesselWithInletAndLiquidOutletManifold"
import { ComponentSplitter } from "./components/ComponentSplitter/ComponentSplitter"
import { Deaerator } from "./components/Deaerator/Deaerator"
import { HeatExchanger } from "./components/HeatExchanger/HeatExchanger"
import { StreamUnit } from "./components/StreamUnit/StreamUnit"

interface UnitPanelProps {
  unit: NodeState
  onChange?: () => void
}

export const NodeUnitPanel = (props: UnitPanelProps) => {
  const {unit, onChange} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const {data, run} = useRequest(() => getSimUnitData({sId: flowSimulation?.id, id: unit.id}))
  const topologyState = useSelector(getTopologyState)

  useUpdateEffect(() => {
    if (topologyState) {
      run()
    }
  }, [topologyState])

  const getContent = () => {
    switch (unit.equipment.type) {
      case EquipmentType.Valves: {
        return <ValveUnit unit={unit} data={data} reload={run} />
      }
      case EquipmentType.BatteryLimit: {
        return <BatteryLimit unit={unit} data={data} reload={run} />
      }
      case EquipmentType.StreamSplitter: {
        return <StreamSplitter unit={unit} data={data} reload={run} />
      }
      case EquipmentType.StreamMixer: {
        return <StreamMixer unit={unit} data={data} reload={run} />
      }
      case EquipmentType.Compressor:
      case EquipmentType.Pump: {
        return <Pumps unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.Reactor: {
        return <Reactor unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.Vessel: {
        return <VerticalVessel unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.SteamDrum: {
        return <VesselWithInletAndLiquidOutletManifold unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.ComponentSplitter: {
        return <ComponentSplitter unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.HeatExchanger: {
        return <HeatExchanger unit={unit} data={data} onChange={onChange} />
      }
      case EquipmentType.Stream: {
        return <StreamUnit unitId={unit.id} />
      }
      case EquipmentType.Burner: {
        return <Burner unit={unit} data={data} reload={run}/>
      }
      case EquipmentType.Deaerator: {
        return <Deaerator unit={unit} data={data} reload={run}/>
      }
      default: {
        return null
      }
    }
  }

  
  const content = getContent()
  return <div style={{width: '100%', height: '100%'}}>
    <div className="unit-container">
      <div className={classNames('unit-header', 'flex-space-btw')}>
        <div>{unit.equipment.name}</div>
        <UnitTag unit={unit} />
      </div>
      {content}
    </div>
  </div>
}